import { QueryClient } from '@tanstack/query-core';

export class QueryClientSingleton {
  // this is a singleton class that references itself
  private static _instance: QueryClientSingleton | null = null;
  private static _client: QueryClient | null = null;

  private constructor() {
    if (QueryClientSingleton._instance) {
      return QueryClientSingleton._instance;
    }

    QueryClientSingleton._instance = this;

    return this;
  }

  static get client() {
    return QueryClientSingleton._client;
  }

  static setClient(queryClient: QueryClient) {
    if (QueryClientSingleton._client) {
      throw new Error('QueryClient already initialized!');
    }

    QueryClientSingleton._client = queryClient;
  }
}
